import { Link } from 'react-router-dom'

interface BackofficePageProps {
}

export const BackofficePage: React.FC<BackofficePageProps> = () => {
    return (
        <section className="backoffice-page page-content-padding">
            <div className="backoffice-landing">
                <p className="backoffice-landing__eyebrow">Back-office audit preview</p>
                <h1>Operational audit trail</h1>
                <p className="backoffice-landing__text">
                    The first audited flows are live: user updates and admin-user setup now write structured audit rows.
                    The snippets now appear where those actions happen, instead of in a separate screen.
                </p>
                <div className="backoffice-landing__actions">
                    <Link className="secondary" to="/onboarding">Review onboarding</Link>
                </div>
            </div>
        </section>
    )
}
